export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name':
    'Pixartprinting S.p.A. Subject to management and coordination by Cimpress plc',
  'privacy-policy': 'Privacy policy',
  'cookie-policy': 'Cookie policy',
  'informazioni-legali': 'Legal information',
}
